import { render, staticRenderFns } from "./AdminOrganizationRegistrationsList.vue?vue&type=template&id=71c53743&"
import script from "./AdminOrganizationRegistrationsList.vue?vue&type=script&lang=js&"
export * from "./AdminOrganizationRegistrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports